import { makeStyles } from "@material-ui/core/styles";

export default function ProdutoCardCss() {
    return makeStyles((theme) => ({
        collapse: {
            width: "50%",
            borderRadius: "10px",
            backgroundColor: "rgb(217, 217, 217, 0.5)",
            margin: "10px",
        },
        cardList: {
            maxHeight: "350px",
            margin: "10px",
            width: "50%",
            overflow: "auto",
        },
        icons: {
            color: theme.palette.primary.main,
        },
    }));
}
